import { DisplayTable } from "@policoders/ds";
import PageHeader from "@shared/components/page-header";

import { useCompany } from "./company.hook";

export const AdministrationCompaniesPage = () => {
  const { lines, tActions, tColumns, tHeaderButtons, handleEdit } = useCompany();

  return (
    <>
      <PageHeader title="Empresas" />
      <DisplayTable
        actions={tActions}
        columns={tColumns}
        headerButtons={tHeaderButtons}
        lines={lines}
        onLineClick={handleEdit}
      />
    </>
  );
};
